var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEditBanner = function SvgEditBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.285 18.266c-.101.101-.101.203-.101.304v5.739H3.309V6.434h12.238c.101 0 .203 0 .305-.102l1.625-1.625c.253-.254.05-.71-.305-.71H3.309A2.438 2.438 0 0 0 .87 6.433v17.875a2.406 2.406 0 0 0 2.438 2.437h17.875a2.438 2.438 0 0 0 2.437-2.437v-7.364c0-.355-.457-.558-.71-.304l-1.626 1.625Zm7.922-10.207a2.973 2.973 0 0 0 0-4.215L27.023 1.66a2.973 2.973 0 0 0-4.214 0L9.504 14.965l-.508 4.62a2.062 2.062 0 0 0 2.285 2.286l4.621-.508L29.207 8.06ZM24.23 9.582l-9.445 9.445-3.351.407.406-3.352 9.445-9.445 2.945 2.945Zm3.25-4.012c.254.203.254.508.051.762l-1.574 1.574-2.945-2.996 1.523-1.523a.476.476 0 0 1 .762 0L27.48 5.57Z",
    fill: "#fff"
  })));
};

export default SvgEditBanner;